import { getBancos, deleteBanco, newBanco, updateBanco, getCatMensualidades, getMensualidadesBanco, newMensulidadesBanco, deleteMensualidadBanco, putMensulidadesBanco } from "../services/bancoServices"
const dataInicial = {
    bancos: [],
    banco: {},
    exito: 0,
    editar: false,
    listaMensualidades: [],
    listaMensualidadesBanco: [],
    modalMensualidad: false,
    mensualidadBanco: {},
    editarMensualidadBanco: false
}
const GET_BANCO_ALL_ACTION = "GET_BANCO_ALL_ACTION"
const GET_BANCO_DETALLE_ACTION = "GET_BANCO_DETALLE_ACTION"
const GET_BANCO_CAT_MENSUALIDADES_ACTION = "GET_BANCO_CAT_MENSUALIDADES_ACTION"
const GET_BANCO_MENSUALIDADES_ACTION = "GET_BANCO_MENSUALIDADES_ACTION"
const DELETE_BANCO_MENSUALIDAD_ACTION = "DELETE_BANCO_MENSUALIDAD_ACTION"
const NEW_BANCO_MENSUALIDAD_ACTION = "NEW_BANCO_MENSUALIDAD_ACTION"
const UPDATE_BANCO_MENSUALIDAD_ACTION = "UPDATE_BANCO_MENSUALIDAD_ACTION"
const DELETE_BANCO_ACTION = "DELETE_BANCO_ACTION"
const UPDATE_BANCO_ACTION = "UPDATE_BANCO_ACTION"
const NEW_BANCO_ACTION = "NEW_BANCO_ACTION"
const MODAL_BANCO_ACTION = "MODAL_BANCO_ACTION"
const GET_BANCO_MENSUALIDAD = "GET_BANCO_MENSUALIDAD"

export default function bancoReducer(state = dataInicial, action) {
    switch (action.type) {
        case UPDATE_BANCO_MENSUALIDAD_ACTION:
            return { ...state, exito: action.payload.exito }
        case GET_BANCO_MENSUALIDAD:
            return { ...state, mensualidadBanco: action.payload.mensualidadBanco, editarMensualidadBanco: action.payload.editarMensualidadBanco }
        case MODAL_BANCO_ACTION:
            return { ...state, modalMensualidad: action.payload.modalMensualidad }
        case NEW_BANCO_MENSUALIDAD_ACTION:
            return { ...state, exito: action.payload.exito }
        case DELETE_BANCO_MENSUALIDAD_ACTION:
            return { ...state, exito: action.payload.exito }
        case GET_BANCO_MENSUALIDADES_ACTION:
            return { ...state, listaMensualidadesBanco: action.payload.listaMensualidadesBanco }
        case GET_BANCO_CAT_MENSUALIDADES_ACTION:
            return { ...state, listaMensualidades: action.payload.listaMensualidades }
        case GET_BANCO_ALL_ACTION:
            return { ...state, bancos: action.payload.bancos }
        case GET_BANCO_DETALLE_ACTION:
            return { ...state, banco: action.payload.banco, editar: action.payload.editar }
        case DELETE_BANCO_ACTION:
            return { ...state, exito: action.payload.exito }
        case UPDATE_BANCO_ACTION:
            return { ...state, exito: action.payload.exito }
        case NEW_BANCO_ACTION:
            return { ...state, exito: action.payload.exito }
        default:
            return state;
    }
}
export const obtenerMensualidadBanco = ({ mensualidadBanco, editar }) => (dispatch) => {
    dispatch({
        type: GET_BANCO_MENSUALIDAD,
        payload: {
            mensualidadBanco: mensualidadBanco,
            editarMensualidadBanco: editar
        },
    })
}
export const openModalMensualidad = ({ open }) => (dispatch) => {
    dispatch({
        type: MODAL_BANCO_ACTION,
        payload: {
            modalMensualidad: open
        },
    })
}
export const actulizaMensualidadBanco = ({IdBancoMensualidad, IdBanco, IdMensualidad, SobreTasa }) => async (dispatch) => {
    return await putMensulidadesBanco({ IdBancoMensualidad, IdBanco, IdMensualidad, SobreTasa }).then(Response => {
        dispatch({
            type: UPDATE_BANCO_MENSUALIDAD_ACTION,
            payload: {
                exito: 1
            },
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const eliminarMensualidadBanco = ({ IdBancoMensualidad }) => async (dispatch) => {
    return await deleteMensualidadBanco({ IdBancoMensualidad }).then(Response => {
        dispatch({
            type: DELETE_BANCO_MENSUALIDAD_ACTION,
            payload: {
                exito: 1
            },
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const agregarMensulidadBanco = ({ IdBanco, IdMensualidad, SobreTasa }) => async (dispatch) => {
    return await newMensulidadesBanco({ IdBanco, IdMensualidad, SobreTasa }).then(Response => {
        dispatch({
            type: NEW_BANCO_MENSUALIDAD_ACTION,
            payload: {
                exito: 1
            },
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const obtenerMensualidadesBanco = ({ IdBanco }) => async (dispatch) => {
    return await getMensualidadesBanco({ IdBanco }).then(Response => {
        dispatch({
            type: GET_BANCO_MENSUALIDADES_ACTION,
            payload: {
                listaMensualidadesBanco: Response
            },
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const obtenerMensualidades = () => async (dispatch) => {
    return await getCatMensualidades().then(Response => {
        dispatch({
            type: GET_BANCO_CAT_MENSUALIDADES_ACTION,
            payload: {
                listaMensualidades: Response
            },
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const targetBancoAction = ({ banco, editar }) => (dispatch) => {
    dispatch({
        type: GET_BANCO_DETALLE_ACTION,
        payload: {
            banco,
            editar
        },
    });
}

export const obtenerBancosAllAction = () => async (dispatch) => {
    return await getBancos().then(Response => {
        dispatch({
            type: GET_BANCO_ALL_ACTION,
            payload: {
                bancos: Response,
            },
        });
        return Response
    }).catch(Error => {
        return []
    })
}
export const nuevoBancoAction = ({ Nombre, TasaCobro }) => async (dispatch) => {
    return await newBanco({ Nombre, TasaCobro }).then(Response => {
        dispatch({
            type: NEW_BANCO_ACTION,
            payload: {
                exito: 1,
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}
export const actulizaBancoAction = ({ idBanco, Estatus, Nombre, TasaCobro }) => async (dispatch) => {
    return await updateBanco({ idBanco, Estatus, Nombre, TasaCobro }).then(Response => {
        dispatch({
            type: UPDATE_BANCO_ACTION,
            payload: {
                exito: 1,
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}
export const eliminarBancoAction = ({ idBanco }) => async (dispatch) => {
    return await deleteBanco({ idBanco }).then(Response => {
        dispatch({
            type: DELETE_BANCO_ACTION,
            payload: {
                exito: 1,
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}